import React, { memo } from 'react';

type ContextProps = {
    showContent: boolean;
};

const EditGedoata: React.FC<ContextProps> = ({ showContent }) => {
    if (!showContent) return null;
    return <>Coming soon!</>;
};

export default memo(EditGedoata);
